/**
 * Utility functions for date handling with PDT timezone
 */

/**
 * Get current date in Pacific Time (PDT/PST) with time set to midnight
 */
export const getPacificDate = (): Date => {
  const now = new Date();
  
  // Convert to Pacific time
  const pacificTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles'
  }));
  
  // Set time to midnight
  pacificTime.setHours(0, 0, 0, 0);
  
  return pacificTime;
};

/**
 * Format date as YYYY-MM-DD
 */
export const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0]; // YYYY-MM-DD format
};

/**
 * Get today's date in Pacific Time formatted as YYYY-MM-DD
 */
export const getTodayInPacific = (): string => {
  return formatDate(getPacificDate());
};

/**
 * Set a date to midnight (00:00:00) for comparison
 */
export const setToMidnight = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};